<template>
  <ion-button
    :disabled="isDisabled"
    @click="handleFileImport"
    class="btn-send"
    fill="clear"
    slot="end"
    shape="round"
  >
    <ion-icon slot="icon-only" :icon="attachOutline"></ion-icon>
  </ion-button>

  <input
    accept="image/jpeg, image/png, application/pdf"
    ref="uploader"
    style="display: none"
    type="file"
    @change="onFileChanged"
  />
</template>
<script setup lang="ts">
  import { attachOutline } from 'ionicons/icons';
  import { IonButton, IonIcon } from '@ionic/vue';
  import { defineEmits, ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { notify } from '@kyvg/vue3-notification';
  import { useToast } from '@/composables/useToast';

  withDefaults(
    defineProps<{
      isDisabled?: boolean;
    }>(),
    {},
  );

  const { t } = useI18n();
  const { showToast } = useToast();

  const isSelecting = ref<boolean>(false);
  const uploader = ref<HTMLInputElement>();
  const fileName = ref('');

  const emit = defineEmits(['file-selected']);

  const onFileChanged = (e: any) => {
    isSelecting.value = false;
    if (e.target.files && e.target.files[0]) {
      const maxFileSize = 5 * 1024 * 1024;
      const file = e.target.files[0];
      if (file.size > maxFileSize) {
        notify({
          type: 'error',
          title: t('validations.invalidFileSize'),
        });
        showToast(t('validations.invalidFileSize', { size: '5MB' }), 'error');

        e.target.value = '';
        return;
      }

      fileName.value = e.target.files[0].name;
      getBase64(e.target.files[0]);
    }
  };

  const getBase64 = (file: File) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      const result = {
        base64File: reader.result,
        fileName: file.name,
        fileType: file.type,
      };
      emit('file-selected', result);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  };

  const handleFileImport = () => {
    isSelecting.value = true;
    window.addEventListener(
      'focus',
      () => {
        isSelecting.value = false;
      },
      { once: true },
    );
    uploader.value?.click();
  };
</script>
<style scoped lang="scss">
  .btn-send {
    margin-top: 13px;
  }
</style>
